import { library } from '@fortawesome/fontawesome-svg-core'

import {
  // Solid icons (fas / fa prefix)
  faArchive,
  faArrowLeft,
  faArrowRight,
  faArrowRightArrowLeft,
  faArrowUpRightFromSquare,
  faBan,
  faBarcode,
  faBriefcaseMedical,
  faCertificate,
  faCheck,
  faCheckCircle,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronDown,
  faCircleLeft,
  faCog,
  faComment,
  faCompass,
  faCopy,
  faCreditCard,
  faDollar,
  faDownload,
  faEdit,
  faExchangeAlt,
  faExclamationTriangle,
  faExternalLinkAlt,
  faFile,
  faFileExcel,
  faFileInvoice,
  faFileInvoiceDollar,
  faFilePdf,
  faFlask,
  faFolderPlus,
  faGift,
  faGreaterThan,
  faInfoCircle,
  faLanguage,
  faLessThan,
  faLightbulb,
  faListOl,
  faMedkit,
  faMicroscope,
  faNotesMedical,
  faPencil,
  faPencilSquare,
  faPlusCircle,
  faReceipt,
  faRecycle,
  faRedo,
  faSave,
  faSearch,
  faSpinner,
  faStar,
  faTh,
  faTimes,
  faTimesCircle,
  faTrash,
  faTruck,
  faUndo,
  faUnlock,
  faUpload,
  faUser,
  faUserCog,
  faUserMd,
  faUsers,
  faVial,
  faStickyNote,
  faWandMagicSparkles
} from '@fortawesome/free-solid-svg-icons'

library.add(
  // Solid
  faArchive,
  faArrowLeft,
  faArrowRight,
  faArrowRightArrowLeft,
  faArrowUpRightFromSquare,
  faBan,
  faBarcode,
  faBriefcaseMedical,
  faCertificate,
  faCheck,
  faCheckCircle,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronDown,
  faCircleLeft,
  faCog,
  faComment,
  faCompass,
  faCopy,
  faCreditCard,
  faDollar,
  faDownload,
  faEdit,
  faExchangeAlt,
  faExclamationTriangle,
  faExternalLinkAlt,
  faFile,
  faFileExcel,
  faFileInvoice,
  faFileInvoiceDollar,
  faFilePdf,
  faFlask,
  faFolderPlus,
  faGift,
  faGreaterThan,
  faInfoCircle,
  faLanguage,
  faLessThan,
  faLightbulb,
  faListOl,
  faMedkit,
  faMicroscope,
  faNotesMedical,
  faPencil,
  faPencilSquare,
  faPlusCircle,
  faReceipt,
  faRecycle,
  faRedo,
  faSave,
  faSearch,
  faSpinner,
  faStar,
  faTh,
  faTimes,
  faTimesCircle,
  faTrash,
  faTruck,
  faUndo,
  faUnlock,
  faUpload,
  faUser,
  faUserCog,
  faUserMd,
  faUsers,
  faVial,
  faWandMagicSparkles,
  faArrowRightArrowLeft,
  faStickyNote
)
